import { createAsyncThunk } from '@reduxjs/toolkit';
import { MarketingPreferencesDTO, UpdateMarketingPreferencesDTO, UsersApi } from '@reposit/api-client';
import { FlashState } from '../../components/FlashMessage';
import { getErrorMessage } from '../../utils/common.utils';
import { UserEntity } from '../entities/entities.types';
import { setFlashMessage } from '../flash-messages/flash-messages.actions';
import { AppState } from '../root.reducer';
import { createStandardUsersApi, runThunkWithAuth } from '../utils/api.utils';

export const USER_COMPLETE_ONBOARDING_INTRODUCTION_STORE_KEY = 'user/complete-onboarding-introduction';
export const FETCH_MARKETING_PREFERENCES_STORE_KEY = 'user/fetch-marketing-preferences';
export const UPDATE_MARKETING_PREFERENCES_STORE_KEY = 'user/update-marketing-preferences';

export const completeOnboardingIntroductionThunk = createAsyncThunk<UserEntity, void, { state: AppState }>(
  USER_COMPLETE_ONBOARDING_INTRODUCTION_STORE_KEY,
  async (_, thunkAPI) => {
    const dispatch = thunkAPI.dispatch;
    const state = thunkAPI.getState();
    try {
      const usersApi: UsersApi = createStandardUsersApi(state);
      const response = await runThunkWithAuth(() => usersApi.completeOnboardingIntroduction(), dispatch);
      return response.data;
    } catch (error) {
      dispatch(
        setFlashMessage({
          key: USER_COMPLETE_ONBOARDING_INTRODUCTION_STORE_KEY,
          message: 'Something went wrong! Please try again',
          state: FlashState.ERROR,
        })
      );
      throw error;
    }
  }
);

export const fetchMarketingPreferencesThunk = createAsyncThunk<MarketingPreferencesDTO, void, { state: AppState }>(
  FETCH_MARKETING_PREFERENCES_STORE_KEY,
  async (_, thunkAPI) => {
    const usersApi: UsersApi = createStandardUsersApi(thunkAPI.getState());
    const response = await runThunkWithAuth(() => usersApi.getMarketingPreferences(), thunkAPI.dispatch);
    return response.data;
  }
);

export const updateMarketingPreferencesThunk = createAsyncThunk<
  MarketingPreferencesDTO,
  UpdateMarketingPreferencesDTO,
  { state: AppState }
>(UPDATE_MARKETING_PREFERENCES_STORE_KEY, async (payload, thunkAPI) => {
  const dispatch = thunkAPI.dispatch;
  try {
    const usersApi: UsersApi = createStandardUsersApi(thunkAPI.getState());
    const response = await runThunkWithAuth(() => usersApi.updateMarketingPreferences(payload), dispatch);
    dispatch(
      setFlashMessage({
        key: UPDATE_MARKETING_PREFERENCES_STORE_KEY,
        message: 'Your preferences have been saved',
        state: FlashState.SUCCESS,
      })
    );
    return response.data;
  } catch (error) {
    const message = getErrorMessage(error);
    dispatch(
      setFlashMessage({
        key: UPDATE_MARKETING_PREFERENCES_STORE_KEY,
        message: typeof message === 'string' ? message : 'Something went wrong! Please try again',
        state: FlashState.ERROR,
      })
    );
    throw error;
  }
});
